import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/sonner@1.7.4_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SupportItem"] */ "/app/src/shared/components/features/customer/support/item/support-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/features/tenant/not-found-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PanelTitle"] */ "/app/src/shared/components/ui/panel/title/panel-title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabNav"] */ "/app/src/shared/components/ui/tab-nav/tab-nav.component.tsx");
